/**
 * The Google "G" mark.
 *
 * Drawn inline rather than loaded from a CDN. The merchant dashboard is a PWA
 * that must render on a counter iPad with a poor connection, and a button whose
 * identity arrives over the network is a button that sometimes has none. The
 * four paths and their brand colours are Google's published mark.
 */

import Svg, { Path } from 'react-native-svg';

/**
 * Renders the Google mark at a given size.
 *
 * @param props Mark size in points.
 * @returns The four-colour G.
 */
export function GoogleMark({ size = 16 }: { size?: number }) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
      <Path
        fill="#4285F4"
        d="M23.06 12.25c0-.85-.08-1.67-.22-2.45H12v4.63h6.2a5.3 5.3 0 0 1-2.3 3.48v2.89h3.72c2.18-2 3.44-4.96 3.44-8.55Z"
      />
      <Path
        fill="#34A853"
        d="M12 23.5c3.11 0 5.72-1.03 7.62-2.79l-3.72-2.89c-1.03.69-2.35 1.1-3.9 1.1-3 0-5.54-2.03-6.45-4.75H1.7v2.98A11.5 11.5 0 0 0 12 23.5Z"
      />
      <Path
        fill="#FBBC05"
        d="M5.55 14.17a6.9 6.9 0 0 1 0-4.34V6.85H1.7a11.5 11.5 0 0 0 0 10.3l3.85-2.98Z"
      />
      <Path
        fill="#EA4335"
        d="M12 4.75c1.69 0 3.21.58 4.4 1.72l3.3-3.3C17.71 1.24 15.1 0 12 0A11.5 11.5 0 0 0 1.7 6.85l3.85 2.98C6.46 7.11 9 4.75 12 4.75Z"
      />
    </Svg>
  );
}
